export const widgetExperimentIds = [979];
export const pdpDefaultMetaTitle = (name) => `Buy ${name}`;
export const pdpDefaultMetaDescription = (name) =>
  `${name} ✅15 Days Easy Return, ✅100% Genuine Products, ✅Trusted by 10+ million young parents`;
export const outOfStockSchema = 'https://schema.org/OutOfStock';
export const inStockSchema = 'https://schema.org/InStock';
export const metaDescriptionAppendString = ` ✅15 Days Easy Return, ✅100% Genuine Products, ✅Trusted by 10+ million young parents`;
